import React, { FC, useCallback } from "react";
import { BarChart, BarChartMarshalledGroup } from "@evergis/charts";
import { useTranslation } from "react-i18next";

import { TooltipContainer, TooltipDescription } from "./styled";

import { declension } from "../../utils/declension";

import { CheckboxStatisticsChartProps } from "./types";

export const CheckboxStatisticsChart: FC<CheckboxStatisticsChartProps> = ({
  data,
  width,
  height,
  selected,
  setSelected,
}) => {
  const { t } = useTranslation("table");

  const customXAxis = useCallback(xAxis => {
    xAxis.remove();
  }, []);

  const customYAxis = useCallback(yAxis => {
    yAxis.remove();
  }, []);

  const customBars = useCallback(
    ({ bars }) => {
      bars.attr("rx", 1).attr("ry", 1);

      const onBarClick = (index: number) => {
        setSelected(
          selected.includes(data[index].groupName as string)
            ? selected.filter(item => item !== (data[index].groupName as string))
            : [...selected, data[index].groupName as string],
        );
      };

      bars._groups.map((items: unknown, index: number) => {
        items[0].addEventListener("click", () => onBarClick(index));
      });
    },
    [data, selected, setSelected],
  );

  const marshalledMap = useCallback(
    items => {
      return items.map(([item]: BarChartMarshalledGroup[]) => [
        {
          ...item,
          color: selected.includes(item.groupName) ? "#00AAFF" : "rgba(48, 69, 79, 0.12)",
        },
      ]);
    },
    [selected],
  );

  return (
    <BarChart
      colors={{ value: "#00AAFF" }}
      width={width}
      data={data}
      height={height || 100}
      customXAxis={customXAxis}
      customYAxis={customYAxis}
      xAxisPadding={0}
      yAxisPadding={0}
      customBars={customBars}
      dynamicTooltipEnable
      isBarTooltip
      renderTooltip={groups => {
        const group = groups[0];

        return (
          <TooltipContainer>
            {group.value} {declension(t("feature1"), t("feature2"), t("feature3"), group.value)}
            {data && <TooltipDescription>{data[group.groupIndex].groupName}</TooltipDescription>}
          </TooltipContainer>
        );
      }}
      barWidth={width / data.length}
      barPadding={0}
      margin={{
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      }}
      marshalledMap={marshalledMap}
    />
  );
};
